module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/kv_shape_bottom-8b28c1cba8781f5a93d3c1e347d2b265.png";